import React, {useEffect, useState} from "react"
import {apiPrivacyInfo} from "../Hooks/Api"
import {useLocal} from "../AppContext"
import {Modal} from "../Components/Modal"
import {MODAL__PRIVACY} from "../Hooks/Modal"
import style from "./PrivacyInfo.css"

export const PrivacyInfo = () => {
    const local = useLocal()
    const [content, setContent] = useState(null)

    useEffect(() => {
        apiPrivacyInfo(local.getLang(true)).then(data => setContent(data))
    }, [])

    return <Modal type={MODAL__PRIVACY} tile={local.__("Datenschutzbestimmungen")} userStyle={{width: "700px", height: "400px"}}>
        <div className={style.privacyInfo} dangerouslySetInnerHTML={{__html: content}}/>
    </Modal>
}
